import { render, staticRenderFns } from "./TgMarquee.vue?vue&type=template&id=ed758318"
import script from "./TgMarquee.vue?vue&type=script&lang=js"
export * from "./TgMarquee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports